<div class="rts-team-area rts-section-gap bg-team">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="rts-title-area team text-center">
                    <p class="pre-title">
                        {{"MEMBER.TITLE" | translate }}
                    </p>
                    <h2 class="title">{{"MEMBER.TEAM" | translate }}</h2>
                </div>
            </div>
        </div>
        <div class="g-5 mt--20">

            <div *ngIf="doctors().length > 0" appSwiper [swiperOptions]="swiperOptions()"
                class="mySwiperh1_team">
                <div class="swiper-wrapper">
                    @for (doctor of doctors(); track $index) {
                    <div class="swiper-slide">
                        <div class="team-single-one-start">
                            <div class="team-image-area">
                                <a>
                                    <img [routerLink]="['/doctor-details',doctor.id]" style="height: 300px;"
                                        [src]="doctor.image.path | imageUrl" alt={{doctor.image.originalName}}>
                                    <div class="team-social" *ngIf="doctor.youTube || doctor.linkedIn || doctor.instagram">
                                        <div class="main">
                                            <i class="fal fa-plus"></i>
                                        </div>
                                        <div class="team-social-one">
                                            <a *ngIf="doctor.youTube" [href]="doctor.youTube" target="_blank">
                                                <i class="fab fa-youtube"></i>
                                            </a>
                                            <a *ngIf="doctor.linkedIn" [href]="doctor.linkedIn" target="_blank">
                                                <i class="fab fa-linkedin"></i>
                                            </a>
                                            <a *ngIf="doctor.instagram" [href]="doctor.instagram" target="_blank">
                                                <i class="fab fa-instagram"></i>
                                            </a>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="single-details">
                                <a [routerLink]="['/doctor-details',doctor.id]">
                                    <h5 class="title">{{doctor.name.length>18?(doctor.name | slice:0:18) + "..."
                                        :doctor.name}}</h5>
                                </a>
                                <p>{{doctor.personalInformation.length>25 ? (doctor.personalInformation | slice: 0 : 25)
                                    + "..." : doctor.personalInformation}}</p>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                <div class="swiper-pagination"></div>

                <!-- Navigation buttons -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                
            </div>
            
        </div>
    </div>
</div>